import { Link } from "react-router";

export default function NotFound() {
  return (
    <div className="py-20 text-center">
      <h1 className="font-display text-4xl font-extrabold">Page not found</h1>
      <p className="mt-2 text-mist">Ye page available nahi hai.</p>
      <Link to="/" className="mt-6 inline-block rounded-lg bg-glow px-5 py-2 font-semibold text-ink">Go home</Link>
    </div>
  );
}
